import script from "./LinkToEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkToEditPage.vue?vue&type=script&setup=true&lang=js"

export default script